module.exports = __webpack_public_path__ + "static/seres-silk-duvet-2-0a02a688656d1eee3f2f65e23eefae3b.png";